"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = function Edit() {
  return _react2.default.createElement(
    "g",
    { id: "edit" },
    _react2.default.createElement("path", {
      d: "M9,379.441118 L9,500 L111.59481,500 L399.918164,205.389222 L294.528942,94.2115768 L9,379.441118 Z M327.749202,55.0220758 L381.80495,0.966327345 L489.987016,109.148393 L435.931267,163.204142 L327.749202,55.0220758 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Edit;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Edit.js
// module id = 2942
// module chunks = 4